export const playerConstants = {
    SHOW_PLAYER: 'SHOW_PLAYER',
    HIDE_PLAYER: 'HIDE_PLAYER',
    ACTIVE_PLAY: 'ACTIVE_PLAY'
};
